<template>
  <div class="v3-popup physical-award-popup" v-show="physicalAwardPopupState">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">
        <div class="physical-award-user-info">
          <div class="physical-award-user-info-item">
            <div class="physical-award-user-info-item-label">
              真實姓名 <i class="required">*</i>
            </div>
            <div class="physical-award-user-info-item-value">
              <input maxlength="20" :class="{ error: physicalAwardUserState.hasNameError }" type="text" v-model="physicalAwardUserState.name" />
            </div>
          </div>
          <div class="physical-award-user-info-item">
            <div class="physical-award-user-info-item-label">
              聯係手機 <i class="required">*</i>
            </div>
            <div class="physical-award-user-info-item-value">
              <input
                maxlength="30"
                type="tel"
                :class="{ error: physicalAwardUserState.hasPhoneError }"
                v-model="physicalAwardUserState.phone"
                @input="handlePhoneInput"
              />
            </div>
          </div>
          <div class="physical-award-user-info-item">
            <div class="physical-award-user-info-item-label">
              收貨地址 <i class="required">*</i>
            </div>
            <div class="physical-award-user-info-item-value">
              <input maxlength="200" :class="{ error: physicalAwardUserState.hasAddressError }" type="text" v-model="physicalAwardUserState.address" />
            </div>
          </div>
        </div>
      </div>
      <div class="v3-popup-content-footer">
        <div class="confirm-btn btns" @click="doubleCheckPhysicalAward"></div>
      </div>
    </div>
  </div>
  <div
    class="v3-popup physical-award-double-check-popup"
    v-show="physicalDoubleCheckPopupState"
  >
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">
        <div class="tips">確認收貨信息後無法更改<br />是否確認？</div>
      </div>
      <div class="v3-popup-content-footer">
        <Transition name="toast">
          <div class="toast" v-if="showToast">提交成功</div>
        </Transition>
        <div class="confirm-btn btns" @click="handleSubmitPhysicalAward"></div>
        <div
          class="cancel-btn btns"
          @click="cancelDoubleCheckPhysicalAward"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, ref } from "vue";

import useGetAward from "@/hooks/useGetAward";

const showCurErrorTips = inject("showCurErrorTips", (code) => {});
const showTipMessage = inject("showTipMessage", (message) => {});
const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));

const {
  physicalAwardUserState,
  physicalAwardPopupState,
  physicalDoubleCheckPopupState,
  doubleCheckPhysicalAward,
  cancelDoubleCheckPhysicalAward,
  submitPhysicalAward,
  resetPhysicalAwardForm,
  showToast
} = useGetAward(showTipMessage, showCurErrorTips);

const handlePhoneInput = (e) => {
  // 只保留数字与+
  physicalAwardUserState.phone = e.target.value.replace(/[^0-9+]/g, "");
};

const handleClose = () => {
  physicalAwardPopupState.value = false;
  physicalDoubleCheckPopupState.value = false;
  resetPhysicalAwardForm();
};

const handleSubmitPhysicalAward = async () => {
  const res = await submitPhysicalAward();
  if (res) {
    // 领取过实物奖励后，将canClaimMaterialReward设置为false
    lotteryAndTaskState.canClaimMaterialReward = false;
  }
};
</script>

<style scoped lang="less">
.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
}

.toast-enter-to {
  opacity: 1;
}

.toast-leave-from {
  opacity: 1;
}

.toast-leave-to {
  opacity: 0;
}
</style>
